import request from './http'

//盈利地址数
export function fetchProfitAddress(data) {
  return request({
    url: `/marketall/btc/v2/profitAddress`,
    method: 'post',
    data
  })
}


//亏损地址数
export function fetchLossAddress(data) {
  return request({
    url: `/marketall/btc/v2/lossAddress`,
    method: 'post',
    data
  })
}

//地址盈亏比
export function fetchProfitRatio(data) {
  return request({
    url: `/marketall/btc/v2/profitRatio`,
    method: 'post',
    data
  })
}

//长期持有者供应量
export function fetchLthSupply(data) {
  return request({
    url: `/marketall/btc/v2/lthSupply`,
    method: 'post',
    data
  })
}

//短期持有者供应量
export function fetchSthSupply(data) {
  return request({
    url: `/marketall/btc/v2/sthSupply`,
    method: 'post',
    data
  })
}

// 已实现价格
export function fetchRealizedPrice(data) {
  return request({
    url: `/marketall/btc/v2/realizedPrice`,
    method: 'post',
    data
  })
}

// 长/短期持有者供应量盈亏比
export function fetchRelativeLthSth(data) {
  return request({
    url: `/marketall/btc/v2/relativeLthSth`,
    method: 'post',
    data
  })
}

// 长期持有者盈利总供应量
export function fetchLthProfitSupply(data) {
  return request({
    url: `/marketall/btc/v2/lthProfitSupply`,
    method: 'post',
    data
  })
}


// 长期持有者亏损总供应量
export function fetchLthLossSupply(data) {
  return request({
    url: `/marketall/btc/v2/lthLossSupply`,
    method: 'post',
    data
  })
}

// 短期持有者盈利总供应量
export function fetchSthProfitSupply(data) {
  return request({
    url: `/marketall/btc/v2/sthProfitSupply`,
    method: 'post',
    data
  })
}

// 短期持有者亏损总供应量
export function fetchSthLossSupply(data) {
  return request({
    url: `/marketall/btc/v2/sthLossSupply`,
    method: 'post',
    data
  })
}

// 短期持有者盈亏比
export function fetchSthProfitRatio(data) {
  return request({
    url: `/marketall/btc/v2/sthProfitRatio`,
    method: 'post',
    data
  })
}


// 短期到长期实现价值比率
export function fetchSLRVRatio(data) {
  return request({
    url: `/marketall/btc/v2/SLRVRatio`,
    method: 'post',
    data
  })
}


// 长期持有者盈亏比
export function fetchLthProfitRatio(data) {
  return request({
    url: `/marketall/btc/v2/lthProfitRatio`,
    method: 'post',
    data
  })
}

//长期持有者每日交易量
export function fetchLthVolume(data) {
  return request({
    url: `/marketall/btc/v2/lthVolume`,
    method: 'post',
    data
  })
}

//交易汇率乘数
export function fetchFrm(data) {
  return request({
    url: `/marketall/btc/v2/frm`,
    method: 'post',
    data
  })
}

//累积价值-销毁天数比
export function fetchCvdd(data) {
  return request({
    url: `/marketall/btc/v2/cvdd`,
    method: 'post',
    data
  })
}

//已平衡价格
export function fetchBalancedPrice(data) {
  return request({
    url: `/marketall/btc/v2/balancedPrice`,
    method: 'post',
    data
  })
}

//市值/交易价值比
export function fetchNvtRatio(data) {
  return request({
    url: `/marketall/btc/v2/nvtRatio`,
    method: 'post',
    data
  })
}

//流通速度
export function fetchVelocity(data) {
  return request({
    url: `/marketall/btc/v2/velocity`,
    method: 'post',
    data
  })
}

//已实现流通市值
export function fetchRcap(data) {
  return request({
    url: `/marketall/btc/rcap`,
    method: 'post',
    data
  })
}
//已实现流通市值(找零消除)
export function fetchEarcap(data) {
  return request({
    url: `/marketall/btc/earcap`,
    method: 'post',
    data
  })
}

//时区购买力
export function getTzbp(data) {
  return request({
    url: `/marketall/exchange/v2/tzbp`,
    method: 'post',
    data
  })
}

//买入大单挂单
export function getBobp(data) {
  return request({
    url: `/marketall/exchange/v2/bobp`,
    method: 'post',
    data
  })
}

//卖出大单挂单
export function getBosp(data) {
  return request({
    url: `/marketall/exchange/v2/bosp`,
    method: 'post',
    data
  })
}
//交易所余额
export function getExchange(data) {
  return request({
    url: `/marketall/btc/v2/ebalance`,
    method: 'post',
    data
  })
}

//交易所余额 下拉框
export function getExchanges(data) {
  return request({
    url: `/marketall/btc/v2/exchanges`,
    method: 'post',
    data
  })
}

//交易所余额ETH
export function getExchangeETH(data) {
  return request({
    url: `/marketall/eth/v2/ebalance`,
    method: 'post',
    data
  })
}

//交易所余额 下拉框ETH
export function getExchangesETH(data) {
  return request({
    url: `/marketall/eth/v2/exchanges`,
    method: 'post',
    data
  })
}

//待交易池详情
export function getMempool(data) {
  return request({
    url: `/marketall/btc/v2/mempool`,
    method: 'post',
    data
  })
}


//NVT信号
export function getNvtSign(data) {
  return request({
    url: `/marketall/btc/v2/nvtSign`,
    method: 'post',
    data
  })
}

//长/短期持有者供应量盈亏分布
export function DistributionLthSth(data) {
  return request({
    url: `/marketall/btc/v2/distributionLthSth`,
    method: 'post',
    data
  })
}

//大额交易ETH 价格接口
export function ethPrice(data) {
  return request({
    url: `/marketall/eth/v2/price`,
    method: 'post',
    data
  })
}

//价值损毁天数倍数
export function getVDD(data) {
  return request({
    url: `/marketall/btc/vdd`,
    method: 'post',
    data
  })
}


